import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface ArticleSelectProps {
    setSelectedArticle: (articleId: number) => void;
    selectedArticle: number | null;
}

type Article = { key: number; value: string };

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const ArticleSelect: React.FC<ArticleSelectProps> = ({ setSelectedArticle, selectedArticle }) => {
    const articles: Article[] = [
        { key: 0, value: 'Multi-produit' },
        { key: 1, value: 'Gasoil' },
        { key: 2, value: 'Essence' },
    ];

    const options: ISelectOption[] = articles.map((article) => ({
        value: article.key.toString(),
        label: article.value,
    }));

    const selectedOption = options.find((option) => option.value === selectedArticle?.toString()) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedArticle(selectedOption ? parseInt(selectedOption.value) : 0);
    };

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={'--- Produit'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default ArticleSelect;
